import { api } from './api';

export const getRteStudent = async (addUrl='') =>{  
    let url=`/rte/students?${addUrl}`;
  return await api.get(url);
};


